// extracted by mini-css-extract-plugin
export default {"container":"g__container--oMROe","duration-container":"g__duration-container--JQ4tO"};